
import Vue from "vue";
import Component from "vue-class-component";

import StaticList from "./StaticList.vue";
import { QuotientFamilial } from "../logic/enums";
import {
  PrixParStatut,
  OptionPrixCamp,
  OptionQuotientFamilial
} from "@/shared/logic/types";
import { isQuotientFamilialActif } from "../logic/utils";

const OptionPrixCampFieldProps = Vue.extend({
  props: {
    option: Object as () => OptionPrixCamp,
    quotientFamilial: Array as () => OptionQuotientFamilial
  }
});

type optionKind = "statut" | "semaine" | "jour";
type kindCrible = { [P in optionKind]: boolean };
@Component({
  components: { StaticList }
})
export default class OptionPrixCampField extends OptionPrixCampFieldProps {
  get kind(): kindCrible {
    const a = this.option.active as optionKind;
    return {
      statut: a == "statut",
      semaine: a == "semaine",
      jour: a == "jour"
    };
  }

  get hasQuotientFamilial() {
    return isQuotientFamilialActif(this.quotientFamilial);
  }

  get itemsStatut() {
    return (this.option.statut || []).map((item: PrixParStatut) => {
      return `${item.statut} : <b>${item.prix ? item.prix + "€" : "gratuit"}</b>
        <i> ${item.description ? "(" + item.description + ")" : ""} </i>`;
    });
  }

  get itemsSemaine() {
    const s = this.option.semaine;
    return [
      "Semaine 1 : <b>" + (s.prix_1 || "-") + "€</b>",
      "Semaine 2 : <b>" + (s.prix_2 || "-") + "€</b>"
    ];
  }

  get itemsQuotientFamilial() {
    const optionQF = this.quotientFamilial || [];
    return optionQF.map((v, i) => {
      let interv = "Plus de " + (v.QuotientMin + 1);
      if (i + 1 < QuotientFamilial.length) {
        interv =
          "Entre " + (v.QuotientMin + 1) + " et " + optionQF[i + 1].QuotientMin;
      }
      return interv + " : <b>" + optionQF[i].Pourcentage + "%</b>";
    });
  }

  get itemsJour() {
    return (this.option.jour || []).map((p, i) => {
      return `Jour ${i + 1} : <b>${p}€</b>`;
    });
  }
}
